import { useNavigate, useSearchParams } from "react-router-dom";

import { NavigateResponse } from "../GPTConvoTypes";
import { BrieMessageBody, BrieMessageHeader } from "./SearchMessage";
import { navigationCommand } from "../../../api/api-hooks/conversations/useUpdateGPTConversations.ts/navigationCommand";

interface Props {
  message: NavigateResponse;
}

export default function NavigateMessage({ message }: Props) {
  const navigate = useNavigate();
  const [, setSearch] = useSearchParams();

  return (
    <div>
      <BrieMessageHeader title="Navigation Command" />
      <BrieMessageBody onClick={handleNavigate} message={message?.Message} />
    </div>
  );

  function handleNavigate() {
    navigationCommand({
      message,
      navigate,
      setSearch,
    });
  }
}
